import { render, staticRenderFns } from "./trainingEventDelete.vue?vue&type=template&id=01e80909&"
import script from "./trainingEventDelete.vue?vue&type=script&lang=js&"
export * from "./trainingEventDelete.vue?vue&type=script&lang=js&"
import style0 from "./trainingEventDelete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports